module.exports = __webpack_public_path__ + "img/greycheck.3ac8b2f6.svg";